import keyboard from "./keyboard.vue"

const Keyboard = {
  install(Vue) {
    Vue.component("keyboard", keyboard)
    Vue.prototype.$keyboard = async function(target, type = "number") {
      try {
        const promise = await _$.progress.create()

        const $package = {
          target: target,
          type: type,
          resolve: e => {
            promise.resolve(e)
          },
          reject: e => {
            promise.reject(e)
          }
        }

        _$.vue.$emit("keyboard", $package)

        return promise.done
      } catch (err) {
        return _$.error(err)
      }
    }
  }
}

export default Keyboard
